/* PUPS Reviews: replaces Loox. Reads reviews from a <script type="application/json" class="pups-rv-data"> inside each .pups-rv root. */
(function () {
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 2.6l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.3 1.3-6.6L2.5 9.5l6.6-.8z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#c9f24a"/><path d="M7 12.5l3.2 3.2L17 9" stroke="#17443d" stroke-width="2.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CAM = '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M9 3L7.2 5H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2h-3.2L15 3H9zm3 14a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"/></svg>';
  var TOPICS = [
    { k: 'breath', label: 'ריח הפה השתפר', re: /ריח|מסריח|מריח/ },
    { k: 'taste', label: 'אוהבים את הטעם', re: /טעם|אוהב|מת על|מתים על|מתות על|עפה על|טורפת|מתלהב|בהתלהבות|נהנ/ },
    { k: 'teeth', label: 'שיניים נקיות', re: /שיניים|הלבינו|לבנות|נקיות|אבנית|כתמים|צהוב/ },
    { k: 'easy', label: 'פשוט לשימוש', re: /נוח|פשוט|מוסיפ|באוכל/ },
    { k: 'service', label: 'שירות ומשלוח', re: /שירות|משלוח|הגיע מהר|מהיר/ }
  ];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(v) {
    var five = STAR + STAR + STAR + STAR + STAR;
    return '<span class="pups-rv__stars" role="img" aria-label="' + v + ' מתוך 5"><span class="s-bg" style="display:inline-flex;gap:2px">' + five.replace(/<svg/g, '<svg class="s-bg"') + '</span><span class="s-fg" style="width:' + (v / 5 * 100) + '%">' + five + '</span></span>';
  }
  function ago(d) {
    if (!d) return '';
    var days = Math.floor((Date.now() - new Date(d + 'T12:00:00').getTime()) / 864e5);
    if (days < 1) return 'היום';
    if (days < 2) return 'אתמול';
    if (days < 7) return 'לפני ' + days + ' ימים';
    if (days < 14) return 'לפני שבוע';
    if (days < 31) return 'לפני ' + Math.floor(days / 7) + ' שבועות';
    if (days < 60) return 'לפני חודש';
    if (days < 365) return 'לפני ' + Math.floor(days / 30) + ' חודשים';
    return 'לפני יותר משנה';
  }
  function textHtml(r) {
    var t = esc(r.t);
    if (r.h) {
      var h = esc(r.h), i = t.indexOf(h);
      if (i > -1) t = t.slice(0, i) + '<mark class="pups-rv__hl">' + h + '</mark>' + t.slice(i + h.length);
    }
    return t;
  }
  function score(r) {
    return (r.img.length ? 100 : 0) + (r.h ? 40 : 0) + Math.min((r.t || '').length, 220) / 8 + r.r * 12 - (r.r < 4 ? 80 : 0) - ((r.t || '').length < 4 ? 60 : 0);
  }

  /* shared lightbox */
  var lb;
  function lightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'pups-rv-lb';
    lb.innerHTML = '<button class="pups-rv-lb__close" aria-label="סגירה">×</button><div class="pups-rv-lb__box"></div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.pups-rv-lb__close')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (lb._go && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) lb._go(e.key === 'ArrowLeft' ? 1 : -1);
    });
    return lb;
  }
  function open(html, wide) {
    var l = lightbox(), box = l.querySelector('.pups-rv-lb__box');
    box.className = 'pups-rv-lb__box' + (wide ? '' : ' pups-rv-form');
    box.innerHTML = html;
    l.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    return box;
  }
  function close() { lb.classList.remove('is-open'); lb._go = null; document.documentElement.style.overflow = ''; }

  function openReview(r, idx) {
    var i = idx || 0;
    var box = open('<div class="pups-rv-lb__img"><img alt=""><div class="pups-rv-lb__dots"></div></div><div class="pups-rv-lb__side">' + cardInner(r, true) + '</div>', true);
    var img = box.querySelector('img'), dots = box.querySelector('.pups-rv-lb__dots');
    if (r.img.length > 1) {
      box.querySelector('.pups-rv-lb__img').insertAdjacentHTML('beforeend', '<button class="pups-rv-lb__nav prev" aria-label="הקודמת">›</button><button class="pups-rv-lb__nav next" aria-label="הבאה">‹</button>');
      box.querySelector('.prev').onclick = function () { go(-1); };
      box.querySelector('.next').onclick = function () { go(1); };
    }
    function show() {
      img.src = r.img[i];
      dots.innerHTML = r.img.length > 1 ? r.img.map(function (_, j) { return '<i class="' + (j === i ? 'on' : '') + '"></i>'; }).join('') : '';
    }
    function go(d) { i = (i + d + r.img.length) % r.img.length; show(); }
    lb._go = r.img.length > 1 ? go : null;
    var x0;
    img.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40 && lb._go) go(dx > 0 ? 1 : -1); });
    show();
    box.querySelectorAll('.pups-rv__hl').forEach(function (m) { m.style.backgroundSize = '100% 74%'; });
  }

  function cardInner(r, full) {
    return '<div class="pups-rv__who"><div class="pups-rv__ava">' + esc((r.n || '?').trim().charAt(0)) + '</div><div><div class="pups-rv__name">' + esc(r.n) + '</div>' +
      (r.v ? '<div class="pups-rv__ver">' + CHECK + 'קנייה מאומתת</div>' : '') + '</div></div>' +
      '<div class="pups-rv__meta">' + stars(r.r) + '<span class="pups-rv__date">' + ago(r.d) + '</span></div>' +
      (r.t && r.t.length > 1 ? '<p class="pups-rv__text">' + textHtml(r) + '</p>' : '') +
      (r['var'] ? '<span class="pups-rv__var">' + esc(r['var']) + '</span>' : '');
  }

  function init(root) {
    if (root.dataset.pupsInit) return;
    root.dataset.pupsInit = '1';
    var dataEl = root.querySelector('script.pups-rv-data');
    var all = dataEl ? JSON.parse(dataEl.textContent) : (window.PUPS_REVIEWS || []);
    var product = root.dataset.product || '';
    var minR = +(root.dataset.minRating || 0);
    var prod = all.filter(function (r) { return r.k === 'p' && (!product || r.p === product) && r.r >= minR; });
    var store = all.filter(function (r) { return r.k === 's'; });
    var showStore = root.dataset.storeTab !== 'false' && store.length;
    var state = { tab: 'p', filter: null, star: null, sort: 'top', shown: 0 };
    var per = window.innerWidth < 750 ? 8 : 12;

    function list() { return state.tab === 'p' ? prod : store; }
    function avg(l) { return l.length ? l.reduce(function (a, r) { return a + r.r; }, 0) / l.length : 0; }
    var a = avg(prod), dist = [5, 4, 3, 2, 1].map(function (s) { return prod.filter(function (r) { return Math.round(r.r) === s; }).length; });
    var photos = [];
    prod.forEach(function (r) { r.img.forEach(function (src, j) { photos.push({ r: r, j: j, src: src }); }); });
    var topics = TOPICS.map(function (t) { return { t: t, n: prod.filter(function (r) { return t.re.test(r.t); }).length }; }).filter(function (x) { return x.n >= 3; });

    root.querySelector('.pups-rv__inner').insertAdjacentHTML('beforeend',
      '<div class="pups-rv__top">' +
        '<div class="pups-rv__score"><div class="pups-rv__avg"><div class="pups-rv__avgnum">' + a.toFixed(1) + '</div>' + stars(Math.round(a * 10) / 10) + '<div class="pups-rv__avgcount">' + prod.length + ' ביקורות</div></div>' +
        '<div class="pups-rv__dist">' + dist.map(function (n, i) { return '<button class="pups-rv__distrow" data-star="' + (5 - i) + '"><span>' + (5 - i) + ' ★</span><span class="pups-rv__bar"><i style="width:0" data-w="' + (prod.length ? n / prod.length * 100 : 0) + '%"></i></span><span>' + n + '</span></button>'; }).join('') + '</div></div>' +
        '<div class="pups-rv__say"><p class="pups-rv__saytitle">✨ מה הלקוחות אומרים</p><p class="pups-rv__saytext">' + esc(root.dataset.summary || '') + '</p>' +
        '<div class="pups-rv__topics">' + topics.map(function (x) { return '<button class="pups-rv__topic" data-topic="' + x.t.k + '">' + x.t.label + '<b>' + x.n + '</b></button>'; }).join('') + '</div></div>' +
      '</div>' +
      (photos.length ? '<div class="pups-rv__stripwrap"><p class="pups-rv__h3">📸 תמונות מלקוחות <small>' + photos.length + ' תמונות</small></p><div class="pups-rv__strip">' +
        photos.map(function (p, i) { return '<button data-ph="' + i + '" aria-label="תמונה מלקוח"><img loading="lazy" src="' + p.src + '" alt="תמונה של לקוח"></button>'; }).join('') + '</div></div>' : '') +
      '<div class="pups-rv__bar2"><div class="pups-rv__tabs"><button class="pups-rv__tab is-on" data-tab="p">ביקורות על המוצר<span>' + prod.length + '</span></button>' +
        (showStore ? '<button class="pups-rv__tab" data-tab="s">ביקורות על החנות<span>' + store.length + '</span></button>' : '') + '</div>' +
        '<div class="pups-rv__tools"><button class="pups-rv__chip" data-photos>' + CAM + ' עם תמונות</button>' +
        '<button class="pups-rv__write">✍️ כתבו ביקורת</button></div></div>' +
      '<div class="pups-rv__grid"></div><div class="pups-rv__morewrap"><button class="pups-rv__loadmore">עוד ביקורות</button><span class="pups-rv__count"></span></div>');

    var grid = root.querySelector('.pups-rv__grid'), moreBtn = root.querySelector('.pups-rv__loadmore'), countEl = root.querySelector('.pups-rv__count');
    var cols = [], current = [];
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.25 }) : null;

    function filtered() {
      var l = list().slice();
      if (state.photos) l = l.filter(function (r) { return r.img.length; });
      if (state.star) l = l.filter(function (r) { return Math.round(r.r) === state.star; });
      if (state.filter) { var t = TOPICS.filter(function (x) { return x.k === state.filter; })[0]; l = l.filter(function (r) { return t.re.test(r.t); }); }
      l = l.filter(function (r) { return state.star || state.sort === 'low' || (r.t && r.t.replace(/[.\s-]/g, '').length > 0) || r.img.length; });
      var s = state.sort;
      l.sort(function (x, y) {
        if (s === 'new') return (y.d || '').localeCompare(x.d || '');
        if (s === 'high') return y.r - x.r || score(y) - score(x);
        if (s === 'low') return x.r - y.r || (y.d || '').localeCompare(x.d || '');
        return score(y) - score(x);
      });
      return l;
    }
    function ncols() { return root.offsetWidth >= 990 ? 3 : 2; }
    function layout() {
      grid.innerHTML = '';
      cols = [];
      for (var i = 0; i < ncols(); i++) { var c = document.createElement('div'); c.className = 'pups-rv__col'; grid.appendChild(c); cols.push(c); }
    }
    function addCards(items) {
      items.forEach(function (r) {
        var el = document.createElement('article');
        el.className = 'pups-rv__card';
        el.innerHTML = (r.img.length ? '<button class="pups-rv__media" aria-label="הגדלת תמונה"><img loading="lazy" src="' + r.img[0] + '" alt="תמונה מהלקוח ' + esc(r.n) + '">' + (r.img.length > 1 ? '<span class="pups-rv__more">' + CAM + '+' + (r.img.length - 1) + '</span>' : '') + '</button>' : '') +
          '<div class="pups-rv__body">' + cardInner(r) + '</div>';
        el._r = r;
        var target = cols.reduce(function (m, c) { return c.offsetHeight < m.offsetHeight ? c : m; }, cols[0]);
        target.appendChild(el);
        if (io) io.observe(el); else el.classList.add('is-in');
      });
    }
    function render(reset) {
      if (reset) { current = filtered(); state.shown = 0; layout(); }
      var next = current.slice(state.shown, state.shown + per);
      state.shown += next.length;
      addCards(next);
      if (!current.length) grid.innerHTML = '<div class="pups-rv__empty">אין ביקורות שמתאימות לסינון הזה</div>';
      moreBtn.style.display = state.shown < current.length ? '' : 'none';
      countEl.textContent = current.length ? 'מוצגות ' + state.shown + ' מתוך ' + current.length : '';
    }

    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('.pups-rv__tab'))) {
        state.tab = b.dataset.tab; state.filter = null; state.star = null;
        root.querySelectorAll('.pups-rv__tab').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        root.querySelectorAll('.pups-rv__topic,.pups-rv__distrow').forEach(function (x) { x.classList.remove('is-on'); });
        render(true);
      } else if ((b = e.target.closest('.pups-rv__topic'))) {
        state.filter = state.filter === b.dataset.topic ? null : b.dataset.topic;
        root.querySelectorAll('.pups-rv__topic').forEach(function (x) { x.classList.toggle('is-on', x.dataset.topic === state.filter); });
        if (state.tab !== 'p') root.querySelector('[data-tab="p"]').click(); else render(true);
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if ((b = e.target.closest('.pups-rv__distrow'))) {
        var s = +b.dataset.star;
        state.star = state.star === s ? null : s;
        root.querySelectorAll('.pups-rv__distrow').forEach(function (x) { x.classList.toggle('is-on', +x.dataset.star === state.star); });
        render(true);
      } else if ((b = e.target.closest('[data-photos]'))) {
        state.photos = !state.photos; b.classList.toggle('is-on', state.photos); render(true);
      } else if ((b = e.target.closest('.pups-rv__loadmore'))) {
        render(false);
      } else if ((b = e.target.closest('[data-ph]'))) {
        var p = photos[+b.dataset.ph]; openReview(p.r, p.j);
      } else if ((b = e.target.closest('.pups-rv__media'))) {
        openReview(b.closest('.pups-rv__card')._r, 0);
      } else if (e.target.closest('.pups-rv__write')) {
        openForm(root);
      }
    });

    var lastCols = ncols();
    window.addEventListener('resize', function () { if (ncols() !== lastCols) { lastCols = ncols(); var n = state.shown; render(true); while (state.shown < n && state.shown < current.length) render(false); } });

    var bars = root.querySelectorAll('.pups-rv__bar i');
    var barIo = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { bars.forEach(function (i) { i.style.width = i.dataset.w; }); barIo.disconnect(); }
    }) : null;
    if (barIo) barIo.observe(root.querySelector('.pups-rv__dist')); else bars.forEach(function (i) { i.style.width = i.dataset.w; });

    render(true);
  }

  function openForm(root) {
    var api = (root.dataset.submitUrl || '').replace(/\/$/, '');
    var box = open('<div class="pups-rv-lb__side"><p class="pups-rv__h3" style="font-size:22px">כתבו לנו ביקורת 🐾</p><form>' +
      '<label>הדירוג שלכם</label><div class="rate">' + [5, 4, 3, 2, 1].map(function (n) { return '<button type="button" data-v="' + n + '" aria-label="' + n + ' כוכבים">★</button>'; }).join('') + '</div>' +
      '<label for="pups-rv-name">שם</label><input id="pups-rv-name" name="name" required maxlength="60">' +
      '<label for="pups-rv-email">אימייל</label><input id="pups-rv-email" name="email" type="email" required maxlength="120">' +
      '<label for="pups-rv-body">הביקורת שלכם</label><textarea id="pups-rv-body" name="body" required maxlength="2000" placeholder="איך הכלב הגיב? מה השתנה?"></textarea>' +
      (api ? '<label for="pups-rv-photo">תמונות (לא חובה, עד 4)</label><input id="pups-rv-photo" name="photos" type="file" accept="image/*" multiple>' : '') +
      '<input name="website" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
      '<p class="pups-rv__err" style="color:#b42318;font-weight:600;margin:0;display:none"></p>' +
      '<button class="send" type="submit">שליחת ביקורת</button></form></div>', false);
    var rating = 5, btns = box.querySelectorAll('.rate button'), form = box.querySelector('form'), err = box.querySelector('.pups-rv__err');
    function paint() { btns.forEach(function (b) { b.classList.toggle('on', +b.dataset.v <= rating); }); }
    btns.forEach(function (b) { b.onclick = function () { rating = +b.dataset.v; paint(); }; });
    paint();
    function done() {
      box.innerHTML = '<div class="pups-rv-lb__side" style="text-align:center;padding:48px 28px"><p style="font-size:44px;margin:0">💚</p><p class="pups-rv__h3" style="justify-content:center;font-size:22px">תודה! הביקורת התקבלה</p><p>היא תופיע באתר אחרי אישור קצר.</p></div>';
    }
    function fail(msg) { err.textContent = msg; err.style.display = 'block'; send.disabled = false; send.textContent = 'שליחת ביקורת'; }
    var send = form.querySelector('.send');
    form.onsubmit = function (e) {
      e.preventDefault();
      if (form.website.value) return done();
      var files = form.photos ? Array.prototype.slice.call(form.photos.files, 0, 4) : [];
      if (files.some(function (f) { return f.size > 25 * 1024 * 1024; })) return fail('כל תמונה עד 25MB');
      send.disabled = true; send.textContent = 'שולחים...'; err.style.display = 'none';
      var req;
      if (api) {
        req = Promise.all(files.map(shrink)).then(function (images) {
          return fetch(api + '/api/submit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
            product_id: root.dataset.productId || '', product_handle: root.dataset.product || '', rating: rating,
            name: form.name.value, email: form.email.value, body: form.body.value, website: form.website.value, images: images }) });
        });
      } else {
        var body = new URLSearchParams();
        body.append('form_type', 'contact');
        body.append('utf8', '✓');
        body.append('contact[name]', form.name.value);
        body.append('contact[email]', form.email.value);
        body.append('contact[body]', 'ביקורת חדשה (' + rating + ' כוכבים) על ' + (root.dataset.product || '') + ':\n\n' + form.body.value);
        req = fetch('/contact', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
      }
      req.then(function (r) { if (!r.ok && r.status !== 302) throw new Error(r.status); done(); })
        .catch(function () { fail('השליחה לא הצליחה. בדקו את החיבור ונסו שוב.'); });
    };
  }

  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var k = Math.min(1, 1600 / Math.max(img.width, img.height)), c = document.createElement('canvas');
        c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url); resolve(c.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = reject; img.src = url;
    });
  }

  function boot() { document.querySelectorAll('.pups-rv').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
